export default import.meta.ROLLDOWN_FILE_URL_jz_rrMHhQF2uXclhGC9bfQ